<template>
  <v-dialog
    persistent
    transition="scale-transition"
    :max-width="$vuetify.breakpoint.xsOnly ? '95%' : '300'"
    v-model="component.dialog_descont"
  >
    <v-form v-model="form">
      <v-card outlined>
        <v-card-title class="text-subtitle-1 pa-3">Valor Desconto?</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3 pb-0">
          <v-select
            label="Tipo Desconto"
            :items="type_descont"
            v-model="component.type_descont"
            required
            item-text="name"
            item-value="value"
            outlined
            dense
            hide-details
            class="mb-3"
          ></v-select>

          <v-text-field
            v-if="component.type_descont === 'PERCENTUAL'"
            outlined
            dense
            v-model="component.valueDescont"
            label="Percentual"
            :rules="[() => (!!component.valueDescont >= 1 && component.valueDescont <= 100) || 'Valor desconto invalido']"
            type="number"
          ></v-text-field>

          <v-text-field
            v-else
            outlined
            dense
            v-model="component.valueDescont"
            label="Valor Dinheiro"
            :rules="[() => (component.valueDescont < component.element.value_subtotal_product) || 'Valor desconto invalido']"
            type="number"
          ></v-text-field>
        </v-card-text>
        <v-card-actions
          class="pa-3"
          :style="$vuetify.breakpoint.xsOnly
            ? 'flex-direction: column; gap: 8px;'
            : 'justify-content: flex-end; gap: 8px;'"
        >
          <v-btn
            depressed
            rounded
            :block="$vuetify.breakpoint.xsOnly"
            class="red darken-4 white--text"
            @click="disableDialog"
          >Cancelar</v-btn>
          <v-btn
            :disabled="!form"
            rounded
            depressed
            :block="$vuetify.breakpoint.xsOnly"
            class="success"
            @click="component.confirm_descont_item()"
          >Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: { component: Object },
  data: () => ({
    quantity: "",
    form: false,
    type_descont: [
      { name: "PERCENTUAL", value: "PERCENTUAL" },
      { name: "DINHEIRO", value: "DINHEIRO" },
    ],
  }),
  methods: {
    disableDialog() {
      this.component.dialog_descont = !this.component.dialog_descont;
    },
  },
};
</script>
